/* eslint-disable @next/next/no-img-element */
import { Fragment } from "react";
import { useRouter } from "next/router";

import { Transition } from "@headlessui/react";

export default function InvalidMeeting() {
  const router = useRouter();
  const { id } = router.query;
  return (
    <Transition
      appear={true}
      show={true}
      as={Fragment}
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed z-10 inset-0 overflow-hidden">
        <div className="relative flex flex-col min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <img
            src="/images/jmCircle.svg"
            className="h-12 2xl:h-32 w-auto absolute top-4 left-4 z-50"
            alt="JustMeetings logo"
          />
          <div className="fixed inset-0 bg-coolGray-900 transition-opacity"></div>
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen">
            &#8203;
          </span>
          {/* Start Modal */}
          <div className="inline-block bg-coolGray-900 rounded-lg text-left transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full sm:px-6 sm:pt-2 sm:pb-8">
            <div className="grid grid-cols-1 gap-2 my-10">
              <div>
                <div className="mt-3 text-center">
                  <h3
                    className="text-lg 2xl:text-4xl leading-6 font-bold text-blueGray-200"
                    id="modal-title"
                  >
                    Invalid Meeting
                  </h3>
                  <div className="mt-2 xl:mt-8">
                    <p className="text-lg text-blueGray-300 mb-2 text-center font-medium">
                      Your url is using{" "}
                      <span className="font-bold text-white">{id}</span>, which
                      is not a valid meeting within JustMeetings.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Modal */}
        </div>
      </div>
    </Transition>
  );
}
